// Generated by purs version 0.15.15
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Ouroboros_Models_Brands_ErrorMessageText from "../Ouroboros.Models.Brands.ErrorMessageText/index.js";
import * as Ouroboros_Models_Brands_HttpStatusCode from "../Ouroboros.Models.Brands.HttpStatusCode/index.js";
import * as Ouroboros_Models_Brands_JwtStatus from "../Ouroboros.Models.Brands.JwtStatus/index.js";
import * as Ouroboros_Models_Brands_JwtSubscriptionStatus from "../Ouroboros.Models.Brands.JwtSubscriptionStatus/index.js";
import * as Ouroboros_Models_Brands_SubscriptionStatus from "../Ouroboros.Models.Brands.SubscriptionStatus/index.js";
import * as Ouroboros_Models_Clients_Authentication from "../Ouroboros.Models.Clients.Authentication/index.js";
import * as Ouroboros_Models_Core_Ok from "../Ouroboros.Models.Core.Ok/index.js";
import * as Ouroboros_Services_FFI_Effect from "../Ouroboros.Services.FFI.Effect/index.js";
import * as Ouroboros_Services_FFI_Env from "../Ouroboros.Services.FFI.Env/index.js";
import * as Ouroboros_Services_FFI_Http from "../Ouroboros.Services.FFI.Http/index.js";
import * as Ouroboros_Services_FFI_Uuid from "../Ouroboros.Services.FFI.Uuid/index.js";
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var validationError = function (message) {
    return {
        type: "ValidationError",
        message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText(message),
        statusCode: Data_Maybe.Nothing.value
    };
};
var unauthorizedError = function (message) {
    return {
        type: "Unauthorized",
        message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText(message),
        statusCode: Data_Maybe.Nothing.value
    };
};
var traceHeaders = function (headers) {
    return Ouroboros_Services_FFI_Http.mkHeaders(append(headers)([ new Data_Tuple.Tuple("X-Trace-ID", Ouroboros_Services_FFI_Uuid.uuidV7(Data_Unit.unit)) ]));
};
var serverError = function (message) {
    return function (status) {
        return {
            type: "ServerError",
            message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText(message),
            statusCode: new Data_Maybe.Just(Ouroboros_Models_Brands_HttpStatusCode.makeHttpStatusCode(Data_Int.toNumber(status)))
        };
    };
};
var passwordServerError = function (message) {
    return function (status) {
        return {
            type: "ServerError",
            message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText(message),
            statusCode: new Data_Maybe.Just(Ouroboros_Models_Brands_HttpStatusCode.makeHttpStatusCode(Data_Int.toNumber(status)))
        };
    };
};
var passwordNetworkError = function (message) {
    return {
        type: "NetworkError",
        message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText(message),
        statusCode: Data_Maybe.Nothing.value
    };
};
var parseJson = function (onError) {
    return function (response) {
        return Ouroboros_Services_FFI_Effect.tryPromise(function (v) {
            return Ouroboros_Services_FFI_Http.responseJson(response);
        })(function (v) {
            return onError("ValidationError");
        });
    };
};
var parseSubscriptionStatus = function (response) {
    return Ouroboros_Services_FFI_Effect.flatMap(parseJson(validationError)(response))(function (payload) {
        var v = Ouroboros_Models_Clients_Authentication.decodeSubscriptionStatusResponse(payload);
        if (v instanceof Data_Either.Left) {
            return Ouroboros_Services_FFI_Effect.fail(validationError("Invalid subscription status payload"));
        };
        if (v instanceof Data_Either.Right) {
            return Ouroboros_Services_FFI_Effect.succeed(Ouroboros_Models_Brands_SubscriptionStatus.unwrap(v.value0.subscription_status));
        };
        throw new Error("Failed pattern match at Ouroboros.Services.Ouroboros.Authentication (line 95, column 5 - line 99, column 76): " + [ v.constructor.name ]);
    });
};
var networkError = function (message) {
    return {
        type: "NetworkError",
        message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText(message),
        statusCode: Data_Maybe.Nothing.value
    };
};
var fetchWithTracePassword = function (url) {
    return function (init) {
        return Ouroboros_Services_FFI_Effect.tryPromise(function (v) {
            return Ouroboros_Services_FFI_Http.fetch_(url)(init);
        })(function (v) {
            return passwordNetworkError("Failed to connect to the server. Please check your internet connection.");
        });
    };
};
var fetchWithTrace = function (url) {
    return function (init) {
        return Ouroboros_Services_FFI_Effect.tryPromise(function (v) {
            return Ouroboros_Services_FFI_Http.fetch_(url)(init);
        })(function (v) {
            return networkError("Failed to connect to the server. Please check your internet connection.");
        });
    };
};
var existingAccountError = function (message) {
    return {
        type: "ExistingAccountError",
        message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText(message),
        statusCode: Data_Maybe.Nothing.value
    };
};
var createDefaultAuthenticationClient = /* #__PURE__ */ (function () {
    return {
        createAccount: function (request) {
            return Ouroboros_Services_FFI_Effect.flatMap(fetchWithTrace(Ouroboros_Services_FFI_Env.apiUrl + "/v1/auth/create-account")(Ouroboros_Services_FFI_Http.requestInitJson("POST")(traceHeaders([ new Data_Tuple.Tuple("Content-Type", "application/json") ]))(Foreign.unsafeToForeign(request))))(function (response) {
                var $17 = Ouroboros_Services_FFI_Http.responseStatus(response) === 409;
                if ($17) {
                    return Ouroboros_Services_FFI_Effect.fail(existingAccountError("An account with this email already exists. Please use a different email or log in."));
                };
                var $18 = Ouroboros_Services_FFI_Http.responseStatus(response) === 401;
                if ($18) {
                    return Ouroboros_Services_FFI_Effect.fail(unauthorizedError("The credentials provided were invalid. Please check your email and password, then try again."));
                };
                var $19 = !Ouroboros_Services_FFI_Http.responseOk(response);
                if ($19) {
                    return Ouroboros_Services_FFI_Effect.fail(serverError("Server responded with an error: " + show(Ouroboros_Services_FFI_Http.responseStatus(response)))(Ouroboros_Services_FFI_Http.responseStatus(response)));
                };
                return Ouroboros_Services_FFI_Effect.flatMap(parseJson(validationError)(response))(function (payload) {
                    var v = Ouroboros_Models_Clients_Authentication.decodeCreateAccountResponse(payload);
                    if (v instanceof Data_Either.Left) {
                        return Ouroboros_Services_FFI_Effect.fail(validationError("Invalid create account payload"));
                    };
                    if (v instanceof Data_Either.Right) {
                        return Ouroboros_Services_FFI_Effect.succeed(Ouroboros_Models_Core_Ok.ok);
                    };
                    throw new Error("Failed pattern match at Ouroboros.Services.Ouroboros.Authentication (line 118, column 15 - line 122, column 33): " + [ v.constructor.name ]);
                });
            });
        },
        login: function (request) {
            return Ouroboros_Services_FFI_Effect.flatMap(fetchWithTrace(Ouroboros_Services_FFI_Env.apiUrl + "/v1/auth/login")(Ouroboros_Services_FFI_Http.requestInitJson("POST")(traceHeaders([ new Data_Tuple.Tuple("Content-Type", "application/json") ]))(Foreign.unsafeToForeign(request))))(function (response) {
                var $23 = !Ouroboros_Services_FFI_Http.responseOk(response);
                if ($23) {
                    var $24 = Ouroboros_Services_FFI_Http.responseStatus(response) === 401;
                    if ($24) {
                        return Ouroboros_Services_FFI_Effect.fail(unauthorizedError("Incorrect username or password. Please try again."));
                    };
                    return Ouroboros_Services_FFI_Effect.fail(serverError("Server responded with an error: " + show(Ouroboros_Services_FFI_Http.responseStatus(response)))(Ouroboros_Services_FFI_Http.responseStatus(response)));
                };
                return parseSubscriptionStatus(response);
            });
        },
        refreshJwtToken: Ouroboros_Services_FFI_Effect.catchAll(Ouroboros_Services_FFI_Effect.flatMap(fetchWithTrace(Ouroboros_Services_FFI_Env.apiUrl + "/v1/auth/refresh-jwt")(Ouroboros_Services_FFI_Http.requestInitNoBody("POST")(traceHeaders([ new Data_Tuple.Tuple("Content-Type", "application/json") ]))))(function (response) {
            var $25 = !Ouroboros_Services_FFI_Http.responseOk(response);
            if ($25) {
                var $26 = Ouroboros_Services_FFI_Http.responseStatus(response) === 401;
                if ($26) {
                    return Ouroboros_Services_FFI_Effect.fail(unauthorizedError("Failed to refresh JWT. User is unauthorized."));
                };
                return Ouroboros_Services_FFI_Effect.fail(serverError("Server responded with an error: " + show(Ouroboros_Services_FFI_Http.responseStatus(response)))(Ouroboros_Services_FFI_Http.responseStatus(response)));
            };
            return Ouroboros_Services_FFI_Effect.map(function (subscriptionStatus) {
                return {
                    status: Ouroboros_Models_Brands_JwtStatus.makeJwtStatus("authorized"),
                    subscription_status: Ouroboros_Models_Brands_JwtSubscriptionStatus.makeJwtSubscriptionStatus(subscriptionStatus)
                };
            })(parseSubscriptionStatus(response));
        }))(function (v) {
            return Ouroboros_Services_FFI_Effect.succeed({
                status: Ouroboros_Models_Brands_JwtStatus.makeJwtStatus("unauthorized"),
                subscription_status: Ouroboros_Models_Brands_JwtSubscriptionStatus.makeJwtSubscriptionStatus("not-found")
            });
        }),
        logout: Ouroboros_Services_FFI_Effect.flatMap(fetchWithTrace(Ouroboros_Services_FFI_Env.apiUrl + "/v1/auth/logout")(Ouroboros_Services_FFI_Http.requestInitNoBody("POST")(traceHeaders([  ]))))(function (response) {
            var $27 = Ouroboros_Services_FFI_Http.responseStatus(response) === 401;
            if ($27) {
                return Ouroboros_Services_FFI_Effect.fail(unauthorizedError("Logout failed. User is unauthorized."));
            };
            var $28 = !Ouroboros_Services_FFI_Http.responseOk(response);
            if ($28) {
                return Ouroboros_Services_FFI_Effect.fail(serverError("Server responded with an error: " + show(Ouroboros_Services_FFI_Http.responseStatus(response)))(Ouroboros_Services_FFI_Http.responseStatus(response)));
            };
            return Ouroboros_Services_FFI_Effect.succeed(Ouroboros_Models_Core_Ok.ok);
        }),
        requestPasswordReset: function (request) {
            return Ouroboros_Services_FFI_Effect.flatMap(fetchWithTracePassword(Ouroboros_Services_FFI_Env.apiUrl + "/v1/auth/password-reset/start")(Ouroboros_Services_FFI_Http.requestInitJson("POST")(traceHeaders([ new Data_Tuple.Tuple("Content-Type", "application/json") ]))(Foreign.unsafeToForeign(request))))(function (response) {
                var $29 = !Ouroboros_Services_FFI_Http.responseOk(response);
                if ($29) {
                    return Ouroboros_Services_FFI_Effect.fail(passwordServerError("Server responded with an error: " + show(Ouroboros_Services_FFI_Http.responseStatus(response)))(Ouroboros_Services_FFI_Http.responseStatus(response)));
                };
                return Ouroboros_Services_FFI_Effect.succeed(Ouroboros_Models_Core_Ok.ok);
            });
        },
        completePasswordReset: function (request) {
            return Ouroboros_Services_FFI_Effect.flatMap(fetchWithTracePassword(Ouroboros_Services_FFI_Env.apiUrl + "/v1/auth/password-reset/complete")(Ouroboros_Services_FFI_Http.requestInitJson("POST")(traceHeaders([ new Data_Tuple.Tuple("Content-Type", "application/json") ]))(Foreign.unsafeToForeign(request))))(function (response) {
                var $30 = !Ouroboros_Services_FFI_Http.responseOk(response);
                if ($30) {
                    return Ouroboros_Services_FFI_Effect.fail(passwordServerError("Server responded with an error: " + show(Ouroboros_Services_FFI_Http.responseStatus(response)))(Ouroboros_Services_FFI_Http.responseStatus(response)));
                };
                return Ouroboros_Services_FFI_Effect.succeed(Ouroboros_Models_Core_Ok.ok);
            });
        }
    };
})();
export {
    createDefaultAuthenticationClient
};
//# sourceMappingURL=index.js.map
